document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('cart-recommendations');

  if (!container) return;

  const loadRecommendations = (intent) => {
    return fetch(`${container.dataset.url}&intent=${intent}`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        return doc.querySelector('.cart-recommendations-results');
      });
  };

  loadRecommendations('complementary')
    .then((recommendations) => {
      if (recommendations) {
        container.innerHTML = recommendations.outerHTML;
        return false; // stop fallback
      }

      return loadRecommendations('related');
    })
    .then((recommendations) => {
      if (recommendations) {
        container.innerHTML = recommendations.outerHTML;
      } else if (recommendations === null) {
        container.innerHTML = '';
      }
    })
    .catch((e) => {
      console.error(e);
      container.innerHTML = '';
    });
});